import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import TextAreaInput from '../common/TextAreaInput';

class ContactFormModal extends PureComponent {
  constructor() {
    super();

    this.state = {
      sending: false,
      sent: false,
      error: '',
      message: '',
    };

    this.handleMessageValue = this.handleMessageValue.bind(this);
    this.handleSendMessage = this.handleSendMessage.bind(this);
  }

  handleMessageValue(message) {
    this.setState({ message });
  }

  handleSendMessage() {
    const { csrfToken } = this.props;
    const { error, message } = this.state;

    this.setState({ sending: true });

    if (!message) {
      this.setState({
        error: 'Please make sure you write a message before submitting.',
        sending: false,
      });
      return;
    }

    postRequest('projects/project_lead', {
      contact_message: message,
    }, csrfToken).then(() => {
      if (error) this.setState({ error: '' });
      this.setState({
        sending: false,
        sent: true,
        message: '',
      });
    });
  }

  render() {
    const {
      sent, sending, message, error,
    } = this.state;
    return (
      <ModalTrigger
        triggerText="Contact Sales"
        buttonStyles="link btn-sales"
        submitButtonText="Send Message"
        cancelButton={false}
        showFooter={false}
        triggerType="button"
        onCloseCallback={() => {
          if (sent) this.setState({ sent: false });
        }}
        idKey="contact-support-modal"
      >
        {sent ? (
          <div className="contact-success-body">
            <div className="contact-header">Message sent!</div>
            <p className="contact-secondary">
              Clora will contact you shortly to
              assist with this need.
            </p>
          </div>
        ) : (
          <div className="contact-body">
            <div className="contact-header">Contact Sales</div>
            <p className="contact-secondary">
              How can we help? Describe your
              need and its context.
            </p>
            {error && (
            <div className="error">
              <i className="fas fa-exclamation-triangle" />
              <span>{error}</span>
            </div>
            )}
            <TextAreaInput
              className="form-control fs-hide"
              textAreaPrompt=""
              placeholder=""
              rows={3}
              value={message}
              onAnswerChange={(val) => this.handleMessageValue(val)}
            />
            <div className="contact-footer">
              <Button
                variant="primary"
                onClick={this.handleSendMessage}
                disabled={sending}
                block
              >
                {sending ? 'Sending...' : 'Send Message'}
              </Button>
            </div>
          </div>
        )}
      </ModalTrigger>
    );
  }
}

ContactFormModal.propTypes = {
  csrfToken: PropTypes.string,
};

ContactFormModal.defaultProps = {
  csrfToken: '',
};

export default ContactFormModal;
